import styled, {createGlobalStyle} from "styled-components"
import 'react-awesome-button/dist/styles.css'


const Style = createGlobalStyle`
  .aws-btn {
    --button-default-height: 45px;
    --button-default-font-size: 14px;
    --button-default-border-radius: 2px;
    --button-horizontal-padding: 10px;
    --button-raise-level: 4px;
    --button-hover-pressure: 1;
    --transform-speed: 0.175s;
    
    --button-primary-color: #5E32BA;
    --button-primary-color-dark: #311769;
    --button-primary-color-light: #ffffff;
    --button-primary-color-hover: #704db9;
    --button-primary-color-active: #e91e63;
    --button-primary-border: none;

    --button-secondary-color: #f2f6f9;
    --button-secondary-color-dark: red;
    --button-secondary-color-light: #1e88e5;
    --button-secondary-color-hover: #e1eaf1;
    --button-secondary-border: 2px solid #1e88e5;
    
    --button-anchor-color: #0e4f88;
    --button-anchor-color-dark: #072743;
    --button-anchor-color-light: #ffffff;
    --button-anchor-color-hover: #0d4a7f;
    --button-anchor-border: none;

    &__content {
      font-weight: bold;
      font-size: 20px;
    }
  }
`
export default Style;